import React, { useContext, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import LoadingButton from '../../../components/LoadingButton';
import { useTranslation } from 'react-i18next';
import MuiAlert from '@material-ui/lab/Alert';
import InstalmentPlanService from '../../../services/InstalmentPlanService';
import { AlertContext } from '../../../components/contexts/WithAlertContext';

type DeleteInstalmentPlanDialogProps = {
  isOpen: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  instalmentPlanId: string;
};

const DeleteInstalmentPlanDialog = ({ isOpen, onCancel, onSuccess, instalmentPlanId }: DeleteInstalmentPlanDialogProps) => {
  const { t } = useTranslation('instalmentPlans');
  const [loading, setLoading] = useState(false);
  const alert = useContext(AlertContext);
  const deleteInstalmentPlan = () => {
    setLoading(true);
    InstalmentPlanService.deleteInstalmentPlan(instalmentPlanId)
      .then(() => {
        onSuccess();
      })
      .catch(() => {
        alert.sendAlert('error', 'Something went wrong');
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={isOpen}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return false;
        }
        onCancel();
      }}
      aria-labelledby="alert-dialog-title"
    >
      <DialogTitle id="alert-dialog-title">{t('delete instalment plan')}</DialogTitle>
      <DialogContent dividers>
        <MuiAlert elevation={6} variant="filled" severity="warning">
          {t('delete instalment plan alert')}
        </MuiAlert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {t('global:cancel')}
        </Button>
        <LoadingButton type="button" onClick={() => deleteInstalmentPlan()} loading={loading}>
          {t('global:delete')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteInstalmentPlanDialog;
